import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import MyStorage from '../../common/MyStorage';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import SideMenu from '../../components/side-menu/SideMenu';
import {
	UpdateCartCount,
	UpdateCartAmount
} from "../../redux/actions/postActions";
import { List } from 'react-content-loader'
import { WebApiCalls } from "../../webApiCalls/webApiCalls"
import { userLogout } from "../../redux/actions/postActions";
import { KMTracking } from '../../components/Tracking/KMTracking';
import {Link} from 'react-router-dom'

const MyListLoader = () => <List />
function PaymentMethods(props) {
	const [paymentMethods, setPaymentMethods] = useState(true)
	const [givenName, setGivenName] = useState('');
	const [payment, setPayment] = useState<any>([])
	const [is_loading, setIsLoading] = useState(false)
	let tryCount = 0
	useEffect(() => {
		getPaymentToken('');
		const storage = new MyStorage()
		let userID =  storage.getUserId();
		let accessToken =  storage.getaccess_token();
		const is_logged_in = storage.getloggedIn();
		if (is_logged_in || is_logged_in == 'true') {
			console.log("Auth Token", is_logged_in)
			const given_name = localStorage.getItem('name')?.split(' ')[0];
			setGivenName(given_name ? given_name : '')
		} else {
			props?.history?.push('/login',{from: 'Payment Methods'})
		}
		if(userID && accessToken){
			seeCart()
		  }else{props?.history?.push("/login", { from: "Payment Methods" });}
		let eventData = {
			'location type': props?.location?.state?.from ? props.location.state.from :''
		}
		tracker('Opened Payment Methods Screen', eventData)
		if (props?.history?.location) {
			window.scrollTo(0, 0)
		}
	}, [])
	const tracker = async (eventName, _kmprops) => {
		await KMTracking(eventName, _kmprops)
	}
	const getPaymentToken = async (_accessToken) => {
		console.log('Heloo Props', props)
		setIsLoading(true)
		let accessToken: any = "";
		if (_accessToken) {
			accessToken = _accessToken;
		} else {
			accessToken = await localStorage.getItem("authenticationFrasers");
		}
		await new WebApiCalls().getPaymentToken(accessToken).then((response) => {
			console.log('Payment response = ', response)

			if (response.statusCode == 200 && response.data) {
				if (response.data.payment_token) {
					setPayment([response.data])
					setIsLoading(false)
					if(response.data.length > 0){
						setPaymentMethods(true)
					}
				}
			}
			else if (response.statusCode == 400) {
				if (tryCount == 0) {
					tryCount = tryCount + 1
					getTokenAgain()
					setIsLoading(false)
				}
				else {
					setIsLoading(false)
					setPayment([])
					setPaymentMethods(false)

					// new MyStorage().clearStorage()
					// props.userLogout();
					// localStorage.clear()
					// props?.history?.push("/login",{from:'Payment Methods'})
					// console.log('Session Expired')
				}
			}
			else {
				console.log('try count =', typeof tryCount)
				if (tryCount == 0) {
					tryCount = tryCount + 1
					// getTokenAgain()
					setIsLoading(false)
				}
				else {
					setIsLoading(false)
					setPayment([])
					setPaymentMethods(false)

					// new MyStorage().clearStorage()
					// props.userLogout();
					// localStorage.clear()
					// props?.history?.push("/login",{from:'Payment Methods'})
					// console.log('Session Expired')
				}
			}
		})
	}
	const seeCart = async () => {
		let userID = await localStorage.getItem("UserId");
		let accessToken = await localStorage.getItem("access_token");
		await new WebApiCalls()
			.getCartDetail(userID, accessToken)
			.then(async (Response) => {
				if(Response.errorType){
					//redirect to login if expired
					props?.history?.push("/login", { from: 'Payment Methods' })
				}
			});
	};
	const getTokenAgain = async () => {
		let _name = await localStorage.getItem("name");
		let _contactID = await localStorage.getItem("contactIDFrasers");
		let _email = await localStorage.getItem("emailFrasers");
		let _phoneNumber = await localStorage.getItem("PhoneNumber");
		let _token = await localStorage.getItem("authenticationFrasers");
		let obj = {
			contact_id: _contactID,
			email: _email,
			phoneNumber: _phoneNumber,
			authenticationFrasers: _token,
			name: _name,
			authentication: _token,
		};
		fetchingToken(obj);
	};
	const fetchingToken = async (data) => {

		let obj = {
			contactID: data.contact_id,
			email: data.email,
			authentication: data.authentication,
			phoneNumber: data.phoneNumber,
			name: data.name,
		};
		localStorage.setItem("contactIDFrasers", obj.contactID);
		localStorage.setItem("emailFrasers", obj.email);
		localStorage.setItem("authenticationFrasers", obj.authentication);
		localStorage.setItem("PhoneNumber", obj.phoneNumber);
		localStorage.setItem("name", obj.name);
		const storage = new MyStorage();
		let userID = storage.getUserId();
		let access_token = storage.getaccess_token();
		let ssoCode = storage.getSsoCode()
		if(!userID && !access_token && !ssoCode){
			await new WebApiCalls().getToken(obj).then(async (response) => {
				if (response.AccessToken) {
					localStorage.setItem("UserId", response.AccessToken.UserId);
					localStorage.setItem("access_token", response.AccessToken.access_token);
					localStorage.setItem("SsoCode", response.SsoCode);
					getPaymentToken(response.AccessToken.access_token);
				}
			});
		}
		
	};
	const deletePaymentToken = async (paymentTokenID) => {
		payment.map((item, i) => {
			if (paymentTokenID == item.payment_token_id) {
				payment.splice(i, 1)
			}
		})
		let accessToken = await localStorage.getItem("authenticationFrasers");
		// let userID = await localStorage.getItem("UserId")
		await new WebApiCalls().deletePaymentToken(accessToken, paymentTokenID).then((response) => {
			if (response.statusCode == 200) {
				setTimeout(() => {
					getPaymentToken('')
				}, 2000);
			}

		})
	}
	return (
		<div>
			<div className="viewport"></div>

			{/* /container */}
			<div className="container">

				{/* header */}
				<Header props={props} />
				{/* /header */}

				
				<MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>
				{/* /content */}
				{paymentMethods == true ?
					<div className="content">

						{/* breadcrumb-back */}
						<div className="breadcrumb-back">

							{/* breadcrumb */}
							<div className="breadcrumb" style={{ backgroundColor: "rgb(255,255,255,0.3)" }}>
								<Link to="/">Home</Link>
								<a href="#">Account</a>
								<a onClick={() => { props?.history?.push("/address-book",{from:'Payment Methods'}) }}>Payment Methods</a>
							</div>
							{/* /breadcrumb */}

							<a onClick={() => props?.history?.goBack()} className="backbtn">BACK</a>

						</div>
						{/* /breadcrumb-back */}

						{/* product listing */}
						<div className="account-page">

							{/* two-columns */}
							<div className="two-columns">

								{/* left panel */}
								<SideMenu props={props} />
								{/* /left panel */}

								{/* /right panel */}
								<div className="right-panel">

									{/* address book */}
									<div className="address-book payment-cards">

										{/* address-list */}
										<div className="address-list">

											{/* entry */}
											{is_loading ? <MyListLoader />
												:
												payment.map((item, index) => {
													return <div key={index} className="entry">

														{/* info */}
														<div className="info">
															<div className="card-type">
																<img src={item.title.includes("VISA") || item.title.includes("Visa") || item.title.includes("visa") ? 'images/icon-visa.png' : 'images/icon-mastercard.png'} alt="" />
															</div>
															{item.title}
														</div>
														{/* /info */}
														<a onClick={() => {
															if (item && item.payment_token_id) {
																deletePaymentToken(item.payment_token_id);
															}
														}}>Delete</a>

													</div>
												})}
											{/* /entry */}




										</div>
										{/* /address-list */}

									</div>
									{/* /address-book */}

								</div>
								{/* /right panel */}

							</div>
							{/* /two-columns */}

						</div>
						{/* /product listing */}

					</div>
					:
					<div className="content">

						{/* breadcrumb-back */}
						<div className="breadcrumb-back">

							{/* breadcrumb */}
							<div className="breadcrumb">
								<a onClick={() => { props?.history?.push("/") }}>Home</a>
								<a href="#">Account</a>
								<a onClick={() => { props?.history?.push("/address-book",{from:'Payment Methods'}) }}>Payment Methods</a>
							</div>
							{/* /breadcrumb */}

							<a href="#" onClick={() => { props?.history?.goBack() }} className="backbtn">BACK</a>

						</div>
						{/* /breadcrumb-back */}

						{/* product listing */}
						<div className="account-page">

							{/* two-columns */}
							<div className="two-columns">

								{/* left panel */}
								<SideMenu props={props} />
								{/* /left panel */}

								{/* /right panel */}
								<div className="right-panel">

									<div className="no-order">
										You do not have a payment method saved<br />
										<span>Save a payment method during the checkout by "Save card for future payment".</span>
									</div>

								</div>
								{/* /right panel */}

							</div>
							{/* /two-columns */}

						</div>
						{/* /product listing */}

					</div>
				}
				{/* /content*/}
			</div>

			<Footer props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>


		</div>
	)
}
const mapStateToProps = (state) => {
	const { cart_count,allCategories } = state.UserReducer
	return { cart_count,allCategories }
};
const actions = {
	UpdateCartCount,
	UpdateCartAmount,
	userLogout
};
export default connect(mapStateToProps, actions)(PaymentMethods);